import React from "react";

import CustomTooltip from "../../Interface/Tooltip";
import { AVATAR_SIZE, AVATAR_SIZE_BIG, AvatarImage } from "../../Store/Item";

type AvatarImgProps = {
  alt: string;
  src: string;
  isUsed?: boolean;
  withTooltip?: boolean;
  w?: number | null;
  h?: number | null;
  border?: number;
  rarity?: string;
  portrait?: boolean;
};

const AvatarImg: React.FC<AvatarImgProps> = React.memo(
  ({
    alt,
    src,
    isUsed = false,
    withTooltip = true,
    w = null,
    h = null,
    border = 3,
    rarity,
    portrait = false,
  }) => {
    const tooltipH = portrait ? Math.round(AVATAR_SIZE_BIG * 1.5) : AVATAR_SIZE_BIG;
    const thumbSize = w || AVATAR_SIZE;
    return (
      <CustomTooltip
        backgroundColor={"black"}
        title={
          withTooltip && (
            <img
              src={src}
              alt={alt}
              width={`${AVATAR_SIZE_BIG}px`}
              height={`${tooltipH}px`}
              loading="lazy"
            />
          )
        }
      >
        <AvatarImage
          isUsed={isUsed}
          width={`${thumbSize}`}
          height={`${h || thumbSize}`}
          border={border}
          rarity={rarity}
          portrait={portrait}
        >
          <img
            src={src}
            alt={alt}
            width={`${thumbSize}px`}
            height={`${h || thumbSize}px`}
            loading="lazy"
          />
        </AvatarImage>
      </CustomTooltip>
    );
  }
);

export default AvatarImg;
